module.exports = __webpack_public_path__ + "img/xBlade-logo-02.8cef6166.png";